import {filterBy} from "@progress/kendo-data-query"
import {Button} from "@progress/kendo-react-buttons"
import {Field, Form, FormElement} from "@progress/kendo-react-form"
import {Input} from "@progress/kendo-react-inputs"
import {useInternationalization} from "@progress/kendo-react-intl"
import dayjs from "dayjs"
import {MDBCard, MDBCol, MDBRow} from "mdbreact"
import {useEffect, useState} from "react"
import {
    CustomPrice,
    setSelectedCustomPricingId,
    showManageCustomPricingModal,
} from "../../containers/CustomPrices/customPricesSlice"
import {RootState} from "../../rootReducer"
import {LoadingPanel} from "../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../store"

import {PermissionsChecker} from "../Shared/permissionChecker"
import PricingBody from "./pricingBody"

interface FlatCustomPrice extends CustomPrice {
    flatCustomPrice: string | null
}

const CustomPriceCard = () => {
    const dispatch = useAppDispatch()
    const intl = useInternationalization()
    const customPriceLoadingID = useAppSelector(
        (state: RootState) => state.containers.customPrices.customPriceLoadingID,
    )
    const customPricesData = useAppSelector((state: RootState) => state.containers.customPrices.customPrices)
    const isCustomPriceLoading = useAppSelector(
        (state: RootState) => state.containers.customPrices.isCustomPriceLoading,
    )

    const addCustomPrice = () => {
        dispatch(showManageCustomPricingModal(true))
        dispatch(setSelectedCustomPricingId(0))
    }

    const [customPrices, setCustomPrices] = useState<FlatCustomPrice[] | null>(null)

    useEffect(() => {
        setCustomPrices(
            customPricesData.map(
                customPrice =>
                    ({
                        ...customPrice,
                        flatCustomPrice: null,
                    } as FlatCustomPrice),
            ),
        )
    }, [customPricesData])

    const onChangeHandler = (sourcePrices: CustomPrice[], event: any): void => {
        const formatCurrency = (dayVal: number | null) => intl.formatNumber(dayVal ?? 0, "c")
        const formatDate = (date: Date | null) => dayjs(date).format("DD/MM/YYYY H:mm")

        const transformedCustomPrice = sourcePrices.map(customPrice => ({
            ...customPrice,
            flatCustomPrice: `
            ${formatCurrency(customPrice.monday)}
            ~${formatCurrency(customPrice.tuesday)}
            ~${formatCurrency(customPrice.wednesday)}
            ~${formatCurrency(customPrice.thursday)}
            ~${formatCurrency(customPrice.friday)}
            ~${formatCurrency(customPrice.saturday)}
            ~${formatCurrency(customPrice.sunday)}
            ~${customPrice.pricingTestPackages}
            ~${customPrice.pricingCustomers}
            ~${customPrice.updatedBy}
            ~${formatDate(customPrice.updatedDate)}
            ~${customPrice.customPricingName}`,
        }))

        setCustomPrices(
            filterBy(transformedCustomPrice, {
                logic: "or",
                filters: [{field: "flatCustomPrice", operator: "contains", value: event.value, ignoreCase: true}],
            }),
        )
    }

    return (
        <>
            <div className="d-flex justify-content-between pb-2">
                <Form
                    render={() => (
                        <FormElement style={{width: 300}}>
                            <fieldset className={"k-form-fieldset"}>
                                <Field
                                    onChange={event => onChangeHandler(customPricesData, event)}
                                    name={"priceSearch"}
                                    component={Input}
                                    className="ps-0"
                                    label={"Search custom prices"}
                                />
                            </fieldset>
                        </FormElement>
                    )}
                />
                <PermissionsChecker permission={["CustomPricing.Add"]}>
                    <Button
                        fillMode="flat"
                        themeColor={"primary"}
                        className="buttons-container-button mt-2 mb-2"
                        iconClass="fa fa-plus"
                        onClick={() => addCustomPrice()}
                    >
                        Add New
                    </Button>
                </PermissionsChecker>
            </div>
            <MDBRow className="pe-3">
                {isCustomPriceLoading && <LoadingPanel />}
                {customPrices != null &&
                    customPrices.map((customPrice,index) => (
                        <MDBCol xl="3" lg="4" md="6" sm="12" xs="12" className="pe-0" key={crypto.randomUUID()}>
                            <MDBCard className="mb-3">
                                {customPriceLoadingID !== null &&
                                    customPriceLoadingID === customPrice.customPricingID && <LoadingPanel />}
                                <PricingBody customPrice={customPrice} />
                            </MDBCard>
                        </MDBCol>
                    ))}
            </MDBRow>
        </>
    )
}

export default CustomPriceCard
